import { render } from "./NextButton.vue?vue&type=template&id=15f1451b&scoped=true&ts=true&lang=pug"
import script from "./NextButton.vue?vue&type=script&lang=ts"
export * from "./NextButton.vue?vue&type=script&lang=ts"

import "./NextButton.vue?vue&type=style&index=0&id=15f1451b&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f1451b"]])

export default __exports__